import { gql } from '@apollo/client';
import { DealContactFragment } from './DealContactFragment';
import { CurrencyFragment } from 'graphql/Currency/fragments/CurrencyFragment';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
import { LocationFragment } from 'graphql/Location/fragments/LocationFragment';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
/**
 * @fragment DealClientFragment
 * @since 1.0.0
 */
export const DealClientFragment = gql `
  fragment DealClientFragment on Client {
    id
    name
    number
    isEndClient
    website
    discount
    createdAt
    updatedAt

    contacts {
      ...DealContactFragment
    }

    locations {
      ...LocationFragment
    }

    primaryLocation {
      ...LocationFragment
    }

    image {
      ...MediaFragment
    }

    currency {
      ...CurrencyFragment
    }

    language {
      ...LanguageFragment
    }
  }

  ${DealContactFragment}
  ${LocationFragment}
  ${MediaFragment}
  ${CurrencyFragment}
  ${LanguageFragment}
`;
